import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import {
  ROLE_LABELS_RU,
  invitationTimeLeft,
  roleLabel,
} from '@/pages/team/teamLogic';
import type { Invitation } from '@/pages/team/types';
import { InvitationStatusBadge } from './TeamStatusBadge';

interface PendingInviteRowProps {
  invitation: Invitation;
  onRevoke: (invitation: Invitation) => void;
  revoking: boolean;
  highlighted?: boolean;
}

/** Строка pending-приглашения: почта + роль + статус + «Отозвать». */
export function PendingInviteRow({
  invitation,
  onRevoke,
  revoking,
  highlighted,
}: PendingInviteRowProps) {
  const left = invitationTimeLeft(invitation.expires_at);
  return (
    <TableRow
      className={cn(
        'bg-accent-brand/[0.03]',
        highlighted && 'ring-2 ring-inset ring-accent-brand/50',
      )}
    >
      <TableCell>
        <div className="flex items-center gap-3">
          <span
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-dashed border-accent-brand/50 text-accent-brand"
            aria-hidden
          >
            <Mail className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <div className="truncate font-medium text-foreground">
              {invitation.email}
            </div>
            <div className="text-xs text-muted-foreground">
              {left.expired ? 'Ссылка истекла' : 'Приглашение отправлено'}
            </div>
          </div>
        </div>
      </TableCell>
      <TableCell className="whitespace-nowrap text-muted-foreground">
        {ROLE_LABELS_RU[invitation.intended_role]
          ? roleLabel(invitation.intended_role)
          : invitation.intended_role}
      </TableCell>
      <TableCell>
        <InvitationStatusBadge expired={left.expired} />
      </TableCell>
      <TableCell className="whitespace-nowrap text-sm tabular-nums text-muted-foreground">
        {left.label}
      </TableCell>
      <TableCell className="text-right">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onRevoke(invitation)}
          disabled={revoking}
        >
          Отозвать
        </Button>
      </TableCell>
    </TableRow>
  );
}
